// extracted by mini-css-extract-plugin
export default {"footer":"onfido-sdk-ui-ActiveVideo-Footer-footer"};